import { render, staticRenderFns } from "./CustomerEditHistory.vue?vue&type=template&id=6fe38c2f&scoped=true"
import script from "./CustomerEditHistory.vue?vue&type=script&lang=js"
export * from "./CustomerEditHistory.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditHistory.vue?vue&type=style&index=0&id=6fe38c2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe38c2f",
  null
  
)

export default component.exports